export const Hcurl = "http://180.101.234.99:10001/wisdom315_BusinessAPI_jiangsu/api";//江苏取地址
// export const Hcurl = "http://test/wisdom315_BusinessAPI_jiangsu/api";//江苏取地址

// export const Hcurl = "http://refund.jshcsoft.com/wisdom315_businessAPI_jiangsu/api";//测试获取地址

// export const Hcurl = "http://211.149.250.2:20001/wisdom315_BusinessAPI_jiangsu/api";//测试获取地址
// export const HcurlOther = "http://test/wisdom315_BusinessAPI_jiangsu/api";//测试获取地址
export const HcurlOther = "http://180.101.234.99:10001/wisdom315_BusinessAPI_jiangsu/api";
export const changeNavOpenkey = "changeNavOpenkey";//改变父菜单
export const changeNavSelectkey = "changeNavSelectkey";//点击子菜单
export const showCaseInfo = "showCaseInfo";//获取登记单详情
export const hideCaseInfo = "hideCaseInfo";//获取登记单详情
// export const data_Url = "http://refund.jshcsoft.com/wisdom315_jiangsu/ashx/";//登记单数据接口
// 
// export const data_Url = "http://test/wisdom315_jiangsu/ashx/";//登记单数据接口
export const data_Url = "http://180.101.234.99:10001/Wisdom315/ashx/";//登记单数据接口

//table 文案
export const tabletext = {
  filterTitle: '筛选',
  filterConfirm: '确定',
  filterReset: '重置',
  emptyText: '暂无数据',
};



//export const Hcurl = "http://58.214.252.167:1003/buiness-api-test/api";//江苏测试环境地址
////export const Hcurl = "http://211.149.250.2:20001/wisdom315_BusinessAPI/api";//.2测试获取地址
//export const changeNavOpenkey = "changeNavOpenkey";//改变父菜单
//export const changeNavSelectkey = "changeNavSelectkey";//点击子菜单
//export const showCaseInfo = "showCaseInfo";//获取登记单详情
//export const hideCaseInfo = "hideCaseInfo";//获取登记单详情
//export const data_Url = "http://58.214.252.167:1003/wisdom315Test/ashx/";//江苏测试环境登记单数据接口
////export const data_Url = "http://211.149.250.2:1002/wisdom315/ashx/";//登记单数据接口
////table 文案
//export const tabletext = {
//    filterTitle: '筛选',
//    filterConfirm: '确定',
//    filterReset: '重置',
//    emptyText: '暂无数据',
//};


////批量下载模板地址
// export const UpLoadedFilesUrl = 'http://211.149.250.2:20001/wisdom315_BusinessAPI_JiangSu/UpLoadedFiles/批量登记模版.xlsx';
// ////批量登记文件上传地址
// export const uploadAction = 'http://211.149.250.2:20001/wisdom315_BusinessAPI_JiangSu/api/CompanyCore/UploadWholeFile';
// //江苏测试环境批量下载模板地址
// export const UpLoadedFilesUrl = 'http://refund.jshcsoft.com/wisdom315_BusinessAPI_JiangSu/UpLoadedFiles/批量登记模版.xlsx';
// //江苏测试环境批量登记文件上传地址
// export const uploadAction = 'http://refund.jshcsoft.com/wisdom315_BusinessAPI_JiangSu/api/CompanyCore/UploadWholeFile';


//江苏正式环境批量下载模板地址
export const UpLoadedFilesUrl = 'http://180.101.234.99:10001/wisdom315_BusinessAPI_jiangsu/UpLoadedFiles/批量登记模版.xlsx';
//江苏测试环境批量登记文件上传地址
export const uploadAction = 'http://180.101.234.99:10001/wisdom315_BusinessAPI_jiangsu/api/CompanyCore/UploadWholeFile';





// WEBPACK FOOTER //
// ./src/constants/index.js